export enum UserButtonKeys {
  LoginAs = 'login-as-user',
  Delete = 'delete',
}
